var exports = {
  "k": "xa15a2ab7--2eb769--container",
  "X": "xa15a2ab7--2eb769--pseudolink",
};

module.exports = exports;
